export default "__VITE_ASSET__BDfkL_R8__"